@if (entries$ | async; as entries) {
  @if (entries.length === 0) {
    <div class="cart-content">
      <div class="empty-cart">
        <div class="empty-cart-icon">🛒</div>
        <h2 class="empty-cart-title">Your cart is empty</h2>
        <p class="empty-cart-message">
          Looks like you haven't added any items to your cart yet.
          Browse our premium spray foam insulation products and find the perfect solution for your project.
        </p>
        <a (click)="navigate('/search/active-brands')" class="continue-shopping-primary">Continue Shopping</a>
      </div>
    </div>
  }
}